import axios from 'axios';

// export const bucket_url = 'https://classroom.s3.amazonaws.com/';

let base_url;
let bucket_url;
let retina_student_panel_url;

if (process.env.NODE_ENV === 'production') {
  // base_url = 'https://api.retinalms.com/api'
  // base_url = 'https://web.retinalms.com/server/api';
  base_url = 'https://apidev.retinalms.com/api';
  // base_url = 'https://apia.retinalms.com/server/dev/api';
  bucket_url = 'https://ducomm.s3.amazonaws.com/';
  // retina_student_panel_url = 'https://dev.retinalms.com'
  retina_student_panel_url = 'https://student.retinalms.com'

  // version = 'v0.6.2';
  // base_url = 'https://apidev.retinalms.com/api';
  // socket_url = 'https://apidev.retinalms.com';
  // socket_path = '/socket.io';
  // bucket_url = 'https://ducomm.s3.amazonaws.com/';
} else {
  // base_url = 'https://0ad78610f8f1.ngrok.io/api';
  // socket_url = 'https://0ad78610f8f1.ngrok.io';
  // base_url = 'https://api.retinalms.com/api';
  // socket_url = 'https://api.retinalms.com';

  base_url = 'http://localhost:3141/api';
  // base_url = 'https://apia.retinalms.com/server/dev/api';
  // base_url = 'https://web.retinalms.com/server/api';
  // base_url = 'https://apidev.retinalms.com/api';
  bucket_url = 'https://ducomm.s3.amazonaws.com/';
  retina_student_panel_url = 'http://localhost:3000';
}

const instance = axios.create({
  baseURL: base_url
});

export { base_url, bucket_url, retina_student_panel_url, instance };